import React, { useEffect, useState } from 'react'
import CTAComp from '../components/CTAComp';
import { db } from "../firebase"; // Make sure this imports your Firebase config
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import PackageCard from '../components/packages/PackageCard';
import TravelTypeCard from '../components/TravelTypeCard';
import BespokenImg from '../assets/img/bespoken.jpg';
import CruisesImg from '../assets/img/cruises.jpg';
import AdventureImg from '../assets/img/adventure.jpg';
import WellnessImg from '../assets/img/wellness.jpg';
import WineImg from '../assets/img/wine-food.jpg';
import EcoTravelImg from '../assets/img/eco-travel.jpg';

const luxuryTravelTypes = [
	{ 
	  title: "Bespoke Travel", 
	  description: "Personalized itineraries tailored to your unique tastes and preferences.", 
	  image: BespokenImg 
	},
	{ 
	  title: "Luxury Cruises", 
	  description: "Opulent sea journeys with world-class service and breathtaking views.", 
	  image: CruisesImg
	},
	{ 
	  title: "Adventure Travel", 
	  description: "High-end expeditions to remote and exotic locations with expert guides.", 
	  image: AdventureImg 
	},
	{ 
	  title: "Wellness Retreats", 
	  description: "Experience relaxation and rejuvenation with spa resorts, yoga retreats, and holistic healing programs.", 
	  image: WellnessImg
	},
	{ 
	  title: "Food and Wine Tours", 
	  description: "Savor fine dining, gourmet experiences, and exclusive vineyard tastings.", 
	  image: WineImg 
	},
	{ 
	  title: "Eco-Luxury Travel", 
	  description: "Enjoy sustainability-focused travel experiences without compromising comfort.", 
	  image: EcoTravelImg 
	}
];

const HomePage = () => {
	const [packages, setPackages] = useState([]);
	const [loading, setLoading] = useState(true);
	const [notFound, setNotFound] = useState(false);

	const randomPackages = [...packages].slice(0,4)

	useEffect(() => {
		const fetchPackagesAndDestinations = async () => {
			try {
				// Fetch all packages from the Firestore collection
				const packagesSnapshot = await getDocs(collection(db, "packages"));
				const packagesData = [];
		
				// Loop through all packages and fetch their respective destination data
				for (const docSnapshot of packagesSnapshot.docs) {
				const packageData = { id: docSnapshot.id, ...docSnapshot.data() };
		
				// Fetch the corresponding destination data for each package using destinationId
				let destinationData = null;
				if (packageData.destinationId) {
					const destinationRef = doc(
					db,
					"destinations",
					packageData.destinationId
					);
					const destinationSnap = await getDoc(destinationRef);
					if (destinationSnap.exists()) {
					destinationData = {
						id: destinationSnap.id,
						...destinationSnap.data(),
					};
					}
				}
		
				// Combine the package and destination data into one object
				packagesData.push({
					...packageData,
					destination: destinationData,
				});
				}
		
				// Update state with the combined data
				if (packagesData.length === 0) {
				setNotFound(true);
				}
				setPackages(packagesData);
				setLoading(false);
			} catch (error) {
				console.error("Error fetching data:", error);
				setNotFound(true);
				setLoading(false);
			}
		};
	
		fetchPackagesAndDestinations();
	}, []);
	
	if (loading) {
		return <div>Loading...</div>;
	}
	
	if (notFound) {
		return <div>Packages not found</div>;
	}
	return (
		<div id="home_page">
			<div className='hero-part'>
				<div className="content">
					<h1 className='catchy-line'>Find Your Luxury Destination Now</h1>
					{/* <div className='search-bar'>
						<div className='search-cont'>
							<div className='filter-options'>
								<div className='destination-search'>Where would you like to go?</div>
								<div className='v-divider'></div>
								<div className='date-search'>When are you going?</div>
							</div>
							<button type="submit" className='search-btn'>Search</button>
						</div>
						<div className='search-results'>
							
						</div>
					</div> */}
				</div>
			</div>
			<div className='luxury-travel-section'>
				<div className='sec-header'>
					<h4>What is Luxury Travel?</h4>
					<p>Luxury travel refers to high-end, exclusive, and customized travel experiences that cater to individuals seeking unique, sophisticated, and indulgent journeys.</p>
				</div>
				<div className='row gx-4 gy-4'>
					<div className="col-sm-6">
						<h3>Characteristics of Luxury Travel</h3>
						<ul>
							<li><strong>High-End Accommodations:</strong> 5-star hotels, luxury resorts, villas, and private islands.</li>
							<li><strong>Personalized Service:</strong> Tailor-made experiences, private butlers, and dedicated concierges.</li>
							<li><strong>Exclusive Access:</strong> Private tours, VIP events, and behind-the-scenes experiences.</li>
							<li><strong>Unique Experiences:</strong> Hot air balloon rides, private yacht charters, and guided safaris.</li>
							<li><strong>Fine dining:</strong> Gourmet meals, wine tastings, and private cooking classes.</li>
							<li><strong>Attention to detail:</strong> Impeccable service, luxurious amenities, and meticulous planning.</li>
						</ul>
					</div>
					<div className="col-sm-6">
						<h3>Benefits of Luxury Travel</h3>
						<ul>
							<li><strong>Personalized Attention:</strong> Tailor-made service that caters to individual needs and preferences.</li>
							<li><strong>Relaxation and rejuvenation:</strong> Luxurious amenities and services that promote relaxation and well-being.</li>
							<li><strong>Unforgettable Experiences:</strong> Unique and exclusive experiences that create lifelong memories.</li>
							<li><strong>Networking opportunities:</strong> Exclusive events and experiences that facilitate connections with like-minded individuals.</li>
							<li><strong>Investment in oneself:</strong> Luxury travel as a form of self-care and personal enrichment.</li>
						</ul>
					</div>
				</div>
			</div>
			<div className='travel-types-section'>
				<div className='sec-header'>
					<h4>Types of Luxury Travel</h4>
					<p>Whether you seek adventure, relaxation, fine dining, or sustainability, these premium journeys are designed to create unforgettable memories with impeccable attention to detail.</p>
				</div>
				<div className='travel-type-card-container'>
					{ luxuryTravelTypes && luxuryTravelTypes.map((type,index) => (
						<TravelTypeCard travelType={type} key={index}/>
					))}
				</div>
				
			</div>
			<div className='specials'>
				<div className='sec-header'>
					<h4>Luxury Packages</h4>
					<p>Explore our hand-picked selection of premium travel experiences, offering unparalleled comfort and adventure.</p>
				</div>
				<div className='cards-container'>
					{packages && randomPackages.map((pkg)=>(
						<PackageCard pkg={pkg} setPackages={setPackages}/>
					))}
				</div>
			</div>
			<CTAComp />
		</div>
	)
}

export default HomePage